import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { OverlayPanel } from 'primeng/overlaypanel';
import { ArtTypeService } from 'src/app/Services/art-type.service';
import { ArtistProductSummary, ArtistProductsService, ArtistProductsSummaryRequest, ConsignedProductsRequest } from 'src/app/Services/artistproducts.service';
import { ArtistsService } from 'src/app/Services/artists.service';
import { AuthConfig, AuthService, FCMNotificationActionGroupEnum } from 'src/app/Services/auth.service';
import { CategoryService } from 'src/app/Services/category.service';
import { ConsignmentService, GalleryConsignmentProduct, ProductSyncedOnPlatformDTO } from 'src/app/Services/consignment.service';
import { MessagingService } from 'src/app/Services/messaging.service';
import { SeriesService } from 'src/app/Services/series.service';
import { NotificationsService } from 'src/app/Services/shared/notifications.service';
import { NotificationTypes } from 'src/app/app.enums';
import { ArtistProduct } from 'src/app/models/artistproduct.model';
import { ProductSoldRequest } from 'src/app/models/request/productsoldrequest.model';
import { ImageUtils } from 'src/app/shared/utils/image-utils';
import { TranslocoService } from '@jsverse/transloco';

@Component({
    selector: 'gallery-consignment-products',
    templateUrl: './gallery-consignment-products.v2.component.html',
    styleUrls: ['./gallery-consignment-products.component.css'],
    providers: [ArtistProductsService, ArtistsService, ConsignmentService],
    standalone: false
})
export class GalleryConsignmentProductsComponent implements OnInit {
  public searchText: string = '';
  public filters: ConsignedProductsRequest = {} as ConsignedProductsRequest;
  public statusFilterOptions: SelectItem[] = [
    { label: 'Available', value: 'Available' },
    { label: 'Sold', value: 'Sold' }
  ];
  @ViewChild('op', { static: false }) op!: OverlayPanel;
  hoveredProduct: any | null = null;
  public isOverlayVisible: boolean = false;
  public artistId!: string;
  public galleryProducts: GalleryConsignmentProduct[] = [];
  public galleryProductsLoaded: boolean = false;
  public gallerySquareUpProducts: GalleryConsignmentProduct[] = [];
  public galleryShpifyProducts: GalleryConsignmentProduct[] = [];
  public galleryWoocommerceProducts: GalleryConsignmentProduct[] = [];
  public galleryWixProducts: GalleryConsignmentProduct[] = [];
  public gallerySquareSpaceProducts: GalleryConsignmentProduct[] = [];
  public prouctDetail: GalleryConsignmentProduct = {} as GalleryConsignmentProduct;
  public isProductSoldDialogVisible: boolean = false;
  public isProductDetailDailogVisible: boolean = false;
  public productSoldData: ProductSoldRequest = {};
  public authConfig: AuthConfig = {};
  public connectedArtists: SelectItem[] = [];
  public isReturnToArtistDialogVisible: boolean = false;
  public returnToArtistRequest: ReturnToArtistRequest = { ConsignmentId: null, ArtistProductId: null, Comments: '' };
  public selectedArtistId: SelectItem<any> | undefined;
  public currentConsignedProduct: number = 0;
  public artistArtTypes: SelectItem[] = [];
  public loadingArtistProducts: boolean = false;
  public currentAvailableArtworks: number = 0;
  public artistProducts: ArtistProductSummary[] = [];
  public artTypes: SelectItem[] = [];
  public productCategories: SelectItem[] = [];
  public displayEmojiDialog: boolean = false;
  public filterSquareSyncProducts: boolean = false;
  public filterShopifySyncProducts: boolean = false;
  public filterWoocommerceSyncProducts: boolean = false;
  public filterWixSyncProducts: boolean = false;
  public filterSquareSpaceSyncProducts: boolean = false;

  constructor(private router: Router,
    private route: ActivatedRoute,
    private authService: AuthService,
    private ngxSpinnerService: NgxSpinnerService,
    private notificationsService: NotificationsService,
    private confirmationService: ConfirmationService,
    private artistService: ArtistsService,
    private categoryService: CategoryService,
    private messagingService: MessagingService,
    private ArtTypeService: ArtTypeService,
    private consignmentService: ConsignmentService,
    private artTypeService: ArtTypeService,
    private transloco: TranslocoService,) {
  }

  public ngOnInit(): void {
    this.reciveNotifications()
    this.authConfig = this.authService.getAuthConfig();
    this.route.paramMap.subscribe(params => {
      if (params.has('artistId')) {
        this.artistId = params.get('artistId')!;
        this.getGalleryConsignmentProducts(this.artistId);
        this.getArtistArtTypeDropdownItems(this.artistId);
        this.getPrimaryArtType();
      } else {
        this.getGalleryConsignmentProducts();
      }
    });
    
    this.getArtTypes();
    // this.getPrimaryArtType();
    this.getAllArtist();
  }

  private getArtistArtTypeDropdownItems(artistId: string) {
    this.artistArtTypes = [];
    this.artistService.getArtistArtTypeDropdownItems(artistId).subscribe((artistArtTypes: SelectItem[]) => {
      this.artistArtTypes = artistArtTypes;
    }, (error) => { console.error(error); });
  }

  private getPrimaryArtType(): void {
    this.artTypeService.getPrimaryArtType().subscribe(
      (primaryArtType: SelectItem) => {
        if (primaryArtType) {
          // Add the primary art type to the dropdown options
          this.artistArtTypes = [primaryArtType, ...this.artistArtTypes];
          // Set the primary art type as the default selected value
          this.filters.ArtTypeId = primaryArtType.value;
  
          // Fetch related categories and series for the primary art type
          this.getAllCategoies(primaryArtType.value);
          // this.getAllSeries(primaryArtType.value);
        }
      },
      (error) => {
        console.error('Error fetching primary art type:', error);
      }
    );
  }


   public reciveNotifications() {
      this.messagingService.handleMarkasReadByActionType(FCMNotificationActionGroupEnum.Connection);
     }

  private getArtTypes() {
    var filterRoleBasedArttypes = false;
    this.artTypes = [];
    this.ArtTypeService.fetch(filterRoleBasedArttypes).subscribe(
      (artTypeItems) => {
        this.artTypes = artTypeItems.map((item) => {
          return { label: item.Name, value: item.Id };
        });
        console.log('ArtTypes: ', this.artTypes);
      },
      (error) => {
        console.error(error);
      }
    );
  }

  public onArtTypeChanged($event: SelectItem) {
    this.filters.ArtTypeId = $event.value;
    if (!this.filters.ArtTypeId) {
      this.filters.ProductCategory = undefined;
      this.productCategories = [];
    } else {
      this.getAllCategoies(this.filters.ArtTypeId);
    }
    this.getGalleryConsignmentProducts(this.artistId, this.filters);
  }

  private getAllCategoies(artTypeId: string) {
    this.productCategories = [];
    this.categoryService.fetchCategory(artTypeId).subscribe((category) => {
      this.productCategories = category.map((item) => { return { label: item.Name, value: item.Id } });
    }, (error) => { console.error(error); });
  }

  public onProductCategoriesChange($event: SelectItem) {
    this.filters.ProductCategory = $event.value;
    this.getGalleryConsignmentProducts(this.artistId, this.filters);
  }

public getGalleryConsignmentProducts(artistId: string | null = null, filters: ConsignedProductsRequest = {}) {
  this.loadingArtistProducts = true;
  this.galleryProductsLoaded = false;
  this.ngxSpinnerService.show();
  this.consignmentService.getGalleryConsignmentProducts(artistId, filters).subscribe((galleryProducts: GalleryConsignmentProduct[]) => {
    // Set image and platform IDs from first entry in ProductSyncedOnPlatformDTO
    this.galleryProducts = galleryProducts.map((product) => {
      product.Product.ResizedImageUrl = ImageUtils.getResizedCloudinaryUrl(product.Product.ProductImgUrl || 'assets/images/No-Image.png');
      
      // Initialize all platform IDs
      product.ShopifyProductId = '';
      product.WooCommerceProductId = '';
      product.SquareSpaceProductId = '';
      
      if (Array.isArray(product.ProductSyncedOnPlatformDTO) && product.ProductSyncedOnPlatformDTO.length > 0) {
        product.ProductSyncedOnPlatformDTO.forEach(platform => {
          if (platform.PlatformName === 'Shopify') {
            product.ShopifyProductId = platform.PlatformProductId ?? '';
          } else if (platform.PlatformName === 'WooCommerce') {
            product.WooCommerceProductId = platform.PlatformProductId ?? '';
          } else if (platform.PlatformName === 'SquareSpace') {
            product.SquareSpaceProductId = platform.PlatformProductId ?? '';
          }
        });
      }
      return product;
    });
    this.galleryProductsLoaded = true;

    // Apply platform filters
    if (this.filterSquareSyncProducts) {
      this.galleryProducts = this.galleryProducts.filter(product => product.SquarePosProductId != undefined);
    }
    else if (this.filterShopifySyncProducts) {
      this.galleryProducts = this.galleryProducts.filter(product => product.ShopifyProductId !== '');
    }
    else if (this.filterWoocommerceSyncProducts) {
      this.galleryProducts = this.galleryProducts.filter(product => product.WooCommerceProductId !== '');
    }
    else if (this.filterWixSyncProducts) {
      this.galleryProducts = this.galleryProducts.filter(product => product.WixProductId != undefined);
    }
    else if (this.filterSquareSpaceSyncProducts) {
      this.galleryProducts = this.galleryProducts.filter(product => product.SquareSpaceProductId !== '');
    }

    // Rest of your existing code...
    this.galleryProducts = this.galleryProducts.map((product) => {
      var currentDate = new Date();
      const oneDay = 24 * 60 * 60 * 1000;
      product.AcceptedBeforeXDays = product.GalleryAcceptedDate ? Math.round(Math.abs(((new Date(product.GalleryAcceptedDate)).getTime() - currentDate.getTime()) / oneDay)) : undefined;
      product.SoldBeforeXDays = product.IsProductSold && product.ProductSoldDate ? Math.round(Math.abs(((new Date(product.ProductSoldDate)).getTime() - currentDate.getTime()) / oneDay)) : undefined;

      if (product.GalleryAcceptedDate) {
        const dispatchDate = new Date(product.GalleryAcceptedDate);
        dispatchDate.setDate(dispatchDate.getDate() + 1);
        product.DispatchedDate = dispatchDate;
      } else {
        product.DispatchedDate = undefined;
      }
      return product;
    });

    this.currentConsignedProduct = galleryProducts.filter(p => !p.IsProductSold).length;
    if (this.galleryProducts) {
      this.gallerySquareUpProducts = this.galleryProducts.filter(product => product.SquarePosProductId !== undefined);
      this.galleryShpifyProducts = this.galleryProducts.filter(product => product.ShopifyProductId !== '');
      this.galleryWoocommerceProducts = this.galleryProducts.filter(product => product.WooCommerceProductId !== '');
      this.galleryWixProducts = this.galleryProducts.filter(product => product.WixProductId !== undefined);
      this.gallerySquareSpaceProducts = this.galleryProducts.filter(product => product.SquareSpaceProductId !== '');
    }

    this.loadingArtistProducts = false;
    this.ngxSpinnerService.hide();
  }, (error) => {
    console.error(error);
    this.loadingArtistProducts = false;
    this.ngxSpinnerService.hide();
    this.galleryProductsLoaded = true;
  });
}


  isToday(date: Date): boolean {
    const today = new Date();
    return date.getFullYear() === today.getFullYear() && date.getMonth() === today.getMonth() && date.getDate() === today.getDate();
  }
  dispatchedDaysAgo(date: Date): number {
    const currentDate = new Date();
    const oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
    return Math.round(Math.abs((currentDate.getTime() - date.getTime()) / oneDay));
  }

  private getAllArtist() {
    this.artistService.getArtistsDropdownData().subscribe((artists) => {
      this.connectedArtists = artists;
    }, (error) => { console.error(error); });
  }

  public onArtistChanged($event: any) {
    this.selectedArtistId = this.connectedArtists.find(p => p.value == $event.value);
    this.getGalleryConsignmentProducts($event.value);
  }

  public showProductDetails(artistProduct: GalleryConsignmentProduct) {
    this.router.navigate([artistProduct.ArtistId, 'artworks', artistProduct.Product.Id]);
  }

  public closeDialog() {
    this.isProductSoldDialogVisible = false;
  }

  public onCloseProductSoldDailog($event: boolean) {
    this.isProductSoldDialogVisible = $event
  }

  public onMarkProductAsSold($event: any, selectedProduct: GalleryConsignmentProduct) {
    console.log('selectedProduct', selectedProduct);

    $event.stopPropagation();
    this.isProductSoldDialogVisible = true;
    this.productSoldData = {
      SoldPrice: selectedProduct.SuggestedSalePrice,  //by default, mark the sold price as the suggested price
      ConsignmentId: selectedProduct.ConsignmentId,
      ArtistProductId: selectedProduct.Product.Id,
      SerialNumber: selectedProduct.Product?.SerialNumber,
      ArtistProductName: selectedProduct.Product?.Name,
      ArtistProductImgUrl: selectedProduct.Product?.ProductImgUrl,
      ArtistRevenue: selectedProduct.Product?.ArtistRevenue,
      ShortDescription: selectedProduct.Product?.ArtistShortDescription,
      IsSold: selectedProduct.IsProductSold,
      SuggestedSalePrice: selectedProduct.SuggestedSalePrice,
      Remarks: selectedProduct.Remarks
    }
    this.isProductDetailDailogVisible = false
  }

  public showReturnToArtistDialog($event: any, selectedItem: GalleryConsignmentProduct) {
    $event.stopPropagation();
    this.returnToArtistRequest = {
      ConsignmentId: selectedItem.ConsignmentId,
      ArtistProductId: selectedItem.Product.Id,
      ArtistName: selectedItem.ArtistName,
      ArtistProduct: selectedItem.Product,
      Comments: null
    };
    this.isReturnToArtistDialogVisible = true;
  }

  public returnToArtist($event: any) {
    this.confirmationService.confirm({
      message: this.transloco.translate('galleryConsignmentProducts.confirmReturnToArtist', { productName: this.returnToArtistRequest.ArtistProduct?.Name, artistName: this.returnToArtistRequest.ArtistName }),
      accept: () => {
        this.ngxSpinnerService.show();
        this.consignmentService.returnProductToArtist(this.returnToArtistRequest.ConsignmentId, this.returnToArtistRequest.ArtistProductId, this.returnToArtistRequest.Comments).subscribe((response) => {
          this.ngxSpinnerService.hide();
          if (response.Success) {
            this.getGalleryConsignmentProducts(this.artistId);
            this.isProductDetailDailogVisible = false;
            this.notificationsService.showNotification(this.transloco.translate('galleryConsignmentProducts.success'), this.transloco.translate('galleryConsignmentProducts.productReturnedSuccess'), NotificationTypes.Success);
          } else { console.error(response); this.notificationsService.showNotification(this.transloco.translate('galleryConsignmentProducts.error'), this.transloco.translate('galleryConsignmentProducts.productReturnError'), NotificationTypes.Error); }
          this.isReturnToArtistDialogVisible = false;
        }, (error) => { console.error(error); this.ngxSpinnerService.hide(); this.isReturnToArtistDialogVisible = false; });
      }
    });
  }

  public openEmojiDialog() {
    this.displayEmojiDialog = !this.displayEmojiDialog;
  }

  public addEmoji(emoji: string) {
    console.log('Selected emoji:', emoji);
    this.returnToArtistRequest.Comments = (this.returnToArtistRequest.Comments || '') + emoji;
    this.displayEmojiDialog = false;
  }

  public closeEmojiDialog($event: any) {
    this.displayEmojiDialog = false;
  }


  public FilterByProductName() {
    const MIN_SEARCH_LENGTH = 3; 
    const filterValue = this.filters.Query!.trim().toLowerCase(); // Using filters.Query for ngModel binding
    // Trigger API call if search input meets the length condition or is cleared
    if (filterValue.length >= MIN_SEARCH_LENGTH || filterValue.length === 0) {
      this.getGalleryConsignmentProducts(this.artistId, this.filters); // Trigger API call
    }
  
    // Filter local products based on the search input
    if (this.galleryProducts) {
      if (filterValue.length >= MIN_SEARCH_LENGTH) {
        this.galleryProducts = this.galleryProducts.filter((product) =>
          product.Product.Name && product.Product.Name.toLowerCase().includes(filterValue)
        );
      } else if (filterValue.length === 0) {
        // Reset the product list when the input is cleared
        this.resetGalleryProducts();
      }
    }
  }
  
  // Method to reset the product list
  private resetGalleryProducts() {
    this.getGalleryConsignmentProducts(this.artistId, this.filters);
  }
  

  public clearAllFilters($event: any) {
    this.selectedArtistId = undefined;
    this.filters.Status = '';
    this.filters.Query = '';
    this.filters.ProductCategory = '';
    this.filters.ArtTypeId = '';
    this.artistId = '';
    this.getGalleryConsignmentProducts();
  }

  public onStatusFilterChange($event: any) {
    // this.filters.Status = $event.value.value;
    this.getGalleryConsignmentProducts(this.artistId, this.filters);
  }


  public onProductSold(product: ProductSoldRequest): void {
    console.log(product);
    const index = this.galleryProducts.findIndex(p => p.Product.Id === product.ArtistProductId);
    if (index !== -1) {
      this.galleryProducts[index].IsProductSold = true;
    }
    this.getGalleryConsignmentProducts();
  }


  public openProductInformationDailog(event: Event, productId: string) {
    console.log(productId)
    event.stopPropagation();
    const selectedProduct = this.galleryProducts.find((p) => p.Product.Id == productId)
    if (selectedProduct) {
      this.prouctDetail = { ...selectedProduct };
      this.isProductDetailDailogVisible = true;
    }
  }

  public closeProductInformationDailog() {
    this.isProductDetailDailogVisible = false;
  }

public isWooCommerceSynced(platforms: ProductSyncedOnPlatformDTO[]): boolean {
  return platforms.some(p => p.WooCommerceStoreDetail && p.WooCommerceStoreDetail.Id);
}

public isShopifySynced(platforms: ProductSyncedOnPlatformDTO[]): boolean {
  return platforms.some(p => p.ShopifyStoreDetailDTO && p.ShopifyStoreDetailDTO.Id);
}

public isSquareSpaceSynced(platforms: ProductSyncedOnPlatformDTO[]): boolean {
  return platforms.some(p => p.SquareSpaceSitesDetailDto && p.SquareSpaceSitesDetailDto.Id);
}


}

export class ReturnToArtistRequest {
  ConsignmentId!: string | null;
  ArtistProductId!: string | null;
  ArtistName?: string | null;
  Comments: string | null = null;
  ArtistProduct?: ArtistProduct | null;
}
